import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  listProducts: (params = {}) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (id) => client.get(`/products/${id}`).then((r) => r.data),
  getProductByCode: (code) => client.get(`/products/by-code/${encodeURIComponent(code)}`).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  createProduct: (data) => client.post("/admin/products", data).then((r) => r.data),
  updateProduct: (id, data) => client.put(`/admin/products/${id}`, data).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/admin/products/${id}`).then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  listPublic: (name) => client.get(`/${name}`).then((r) => r.data),
  adminList: (name) => client.get(`/admin/${name}`).then((r) => r.data),
  adminCreate: (name, data) => client.post(`/admin/${name}`, data).then((r) => r.data),
  adminUpdate: (name, id, data) => client.put(`/admin/${name}/${id}`, data).then((r) => r.data),
  adminDelete: (name, id) => client.delete(`/admin/${name}/${id}`).then((r) => r.data),
  settings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (data) => client.put("/admin/settings", data).then((r) => r.data),
  createOrder: (data) => client.post("/orders", data).then((r) => r.data),
  adminOrders: (status) => client.get("/admin/orders", { params: status ? { status } : {} }).then((r) => r.data),
  updateOrderStatus: (id, status) => client.put(`/admin/orders/${id}`, { status }).then((r) => r.data),
  deleteOrder: (id) => client.delete(`/admin/orders/${id}`).then((r) => r.data),
  ordersSummary: (month) => client.get("/admin/orders/summary", { params: month ? { month } : {} }).then((r) => r.data),
  changePassword: (current_password, new_password) => client.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
};

export const assetUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Intentá de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
